var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { fontSizes, lineHeights } from 'syf-component-library/defaultTheme';
export const ListItem = styled.li `
  color: ${({ showActiveStyles, theme }) => showActiveStyles ? `${theme.navigation.activeTabText}` : 'inherit'};
`;
export const TabButton = styled.button `
  min-width: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background-color: transparent;
  border: none;
  font-size: ${fontSizes.root}px;
  line-height: ${lineHeights.root};
  color: ${({ theme }) => `${theme.navigation.activeTabText}`};
  font-weight: bold;
  cursor: pointer;
  padding: 0;
  border-bottom: ${({ showActiveStyles, theme }) => showActiveStyles
    ? `2px solid ${theme.navigation.activeTabBorder}`
    : '2px solid transparent'};

  &:hover {
    border-bottom: ${({ theme }) => `2px solid ${theme.navigation.activeTabBorder}`};
  }
  font-family: 'Open Sans';
`;
const ClickableTab = (_a) => {
    var { handleTabClick, onTabClick, isActive = false, label, index, className, id, forwardRef } = _a, props = __rest(_a, ["handleTabClick", "onTabClick", "isActive", "label", "index", "className", "id", "forwardRef"]);
    return (_jsx(ListItem, Object.assign({ className: className, role: "presentation", showActiveStyles: isActive }, { children: _jsx(TabButton, Object.assign({ "aria-controls": `${id}-content`, "aria-selected": isActive, id: id, ref: forwardRef, role: "tab", showActiveStyles: isActive, tabIndex: isActive ? 0 : -1 }, props, { onClick: () => {
                handleTabClick(index);
                onTabClick(index);
            } }, { children: label })) })));
};
export default ClickableTab;
